import { render, staticRenderFns } from "./service-card.vue?vue&type=template&id=3ead635f&scoped=true&"
import script from "./service-card.vue?vue&type=script&lang=js&"
export * from "./service-card.vue?vue&type=script&lang=js&"
import style0 from "./service-card.vue?vue&type=style&index=0&id=3ead635f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ead635f",
  null
  
)

export default component.exports